import { useState } from "react";
import { useCart } from "../cart/CartContext";
import { resolveStoreHref, storePath } from "../lib/storePaths";

export default function StoreHeader({ store, storeSlug, navLinks = [], cta = null, plain = false }) {
  const { itemCount } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const storeUrl = storePath("", store?.slug || storeSlug);
  const cartUrl = storePath("/cart", store?.slug || storeSlug);
  const customerAreaUrl = storePath("/dashboard", store?.slug || storeSlug);
  const name = store?.name || "Carregando loja...";

  return (
    <header className={`store-header${plain ? " store-header--plain" : ""}${menuOpen ? " is-menu-open" : ""}`}>
      <div className="store-header__inner">
        <a className="store-header__brand" href={storeUrl}>
          {store?.logoUrl ? (
            <img
              className="store-mark store-mark--logo"
              src={store.logoUrl}
              alt={`${name} logo`}
            />
          ) : (
            <div className="store-mark" aria-hidden>
              {name === "Carregando loja..."
                ? "A"
                : name.slice(0, 1).toLocaleUpperCase()}
            </div>
          )}
          <div>
            <p className="store-header__name">{name}</p>
          </div>
        </a>

        {navLinks.length > 0 ? (
          <nav className="store-header__nav" id="store-header-menu" aria-label="Página">
            {navLinks.map((link) => (
              <a
                key={`${link.label}-${link.href}`}
                href={resolveStoreHref(link.href, store?.slug || storeSlug)}
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
          </nav>
        ) : null}

        <nav className="store-header__actions" aria-label="Ações da loja">
          {navLinks.length > 0 ? (
            <button
              type="button"
              className="store-header__menu"
              aria-expanded={menuOpen}
              aria-controls="store-header-menu"
              aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <svg viewBox="0 0 24 24" aria-hidden>
                {menuOpen ? (
                  <path d="M6 6l12 12M18 6 6 18" />
                ) : (
                  <path d="M4 7h16M4 12h16M4 17h16" />
                )}
              </svg>
            </button>
          ) : null}
          <a
            className="header-action"
            href={customerAreaUrl}
            aria-label="Área do cliente"
            title="Área do cliente"
          >
            <svg viewBox="0 0 24 24" aria-hidden>
              <path d="M19 21a7 7 0 0 0-14 0M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" />
            </svg>
          </a>
          <a
            className="header-action header-cart"
            href={cartUrl}
            aria-label={`Carrinho com ${itemCount} ${
              itemCount === 1 ? "item" : "itens"
            }`}
          >
            <svg viewBox="0 0 24 24" aria-hidden>
              <path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L20.2 8H6.1M9.5 20a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm8 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
            </svg>
            {itemCount > 0 && (
              <span>{itemCount > 99 ? "99+" : itemCount}</span>
            )}
          </a>
          {cta?.label && cta?.href ? (
            <a className="store-header__buy" href={resolveStoreHref(cta.href, store?.slug || storeSlug)}>
              {cta.label}
            </a>
          ) : null}
        </nav>
      </div>
    </header>
  );
}
